import React, { useEffect, useRef } from 'react';

const Mission = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-12');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.reveal-trigger');
      elements.forEach(el => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="mission" className="py-24 sm:py-32 bg-cogLight overflow-hidden font-sans text-cogInk border-b border-cogBlue/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        
        {/* Left Content Column (Spans 7 columns) */}
       <div className="reveal-trigger opacity-0 translate-y-12 transition-all duration-800 ease-out lg:col-span-7 order-2 lg:order-1">
  <div className="flex items-center gap-3 mb-4">
    <p className="tracking-[0.2em] text-[0.75rem] font-bold uppercase text-cogCyan">
      Our Mission
    </p>
  </div>

  <h2 className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl text-cogBrand leading-[1.1] mb-8 tracking-tight max-w-2xl">
    Engineering connections that last.
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8 pt-4 border-t border-cogBlue/10">
    <div>
      <p className="text-cogBlue/80 text-sm sm:text-base leading-relaxed">
        Our mission is to deliver reliable, high-quality wiring harness and cable assembly solutions that enable safer, smarter, and more efficient products. Through engineering excellence and precision manufacturing, we help customers transform ideas into dependable solutions.
      </p>
    </div>

    <div>
      <p className="text-cogBlue/80 text-sm sm:text-base leading-relaxed">
        We are committed to continuous improvement, customer collaboration, and uncompromising quality at every stage of development. Every project is approached with the goal of building lasting partnerships founded on trust, innovation, and reliable performance.
      </p>
    </div>
  </div>
</div>
        
        {/* Right Graphical Column (Spans 5 columns - Badge Removed) */}
        <div className="reveal-trigger opacity-0 translate-y-12 transition-all duration-800 ease-out delay-150 lg:col-span-5 order-1 lg:order-2">
          {/* Sharp, framed structural container */}
          <div className="p-2 border border-cogBlue/10 bg-white shadow-md">
            <div 
              className="overflow-hidden aspect-[4/3] sm:aspect-[16/11] bg-cover bg-center filter grayscale contrast-125 hover:grayscale-0 transition-all duration-500"
              style={{ backgroundImage: `url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1200&q=80')` }}
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Mission;